module.exports = __webpack_public_path__ + "static/media/logo_new.622a4c85.png";